import React from 'react';
import styles from './About.module.scss';

const About = () => {
    return(
        <div className={styles.about}>
            <h1 className={styles.__TEMPORALTITLE}>Currently under construction</h1>
        </div>
    );
}

export default About;